import { createProxy } from '../../toolkit/proxy';
export const initialState = {
  loaders: {},
  errors: {},
  groups: [],
  groupsConfiguration: {}
};
export default (overrideState => createProxy(initialState, overrideState));